import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AlertsRoutes, MasterRoutes, SettingsRoutes,} from 'src/app/core/constants/route.constant';
import {CacheConstant} from 'src/app/core/cache/cache.constant';
import {AlertsService} from 'src/app/modules/alerts/alerts.service';
import {IResponse} from 'src/app/shared/models/app';
import {RouteUtilService} from 'src/app/shared/utils/route-util.service';
import {PrincipalService} from '../../core/services/principal.service';
import {DayboardDateService} from '../dayboard-date.service';
import {BreakpointObserver, Breakpoints, BreakpointState} from '@angular/cdk/layout';
import {faBars} from '@fortawesome/free-solid-svg-icons';
import {SessionStorageService} from 'ngx-webstorage';
import {IdnReports, menuOption, NonIdnReports, orgmenuOption} from 'src/app/core/constants/nav.constants';
import {HomeService} from 'src/app/modules/home/home.service';
import {interval} from 'rxjs';
import {PreferenceService} from 'src/app/core/services/preference.service';
import {AppConstant} from 'src/app/core/constants/app.constant';
import {ReceiveShipmentService} from 'src/app/modules/inventory/pages/receive-shipment/receive-shipment.service';
import { EntityVerificationFormComponent } from './entity-verification-form/entity-verification-form.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'nuctrac-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {
  /*********************Properties*********************/
  faBars = faBars;
  menuOption = menuOption;
  orgmenuOption = orgmenuOption;
  menuOptionDisplay: any[] = [];
  menuList: any;
  showSubMenu: boolean = false;
  Url: any;
  alerts: any[] = [];
  alertCount: number = 0;
  hl7alertCount: number = 0;
  hl7alertCountUpdateInterval = 600000;
  isHighAlert: boolean = false;
  showMenubar: boolean = false;
  isIDNAccount: boolean;
  isDigiradAccount: boolean;
  selectedIndex: number;
  isMobileView: boolean;
  manufacturerOrderCount: any = 0;
  isWasteDisabled: boolean = false;
  enablePOLink: any;
  private subscription = {
    authenticated: null,
    alertCounter: null,
    navReset: null,
    reservationUpdate: null,
    preferences: null
  };
  enable340BVerification:boolean = false;
  enableWrittenDirectives: boolean = false;
  manufacturerOrderPref:any;

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    private router: Router,
    private routeUtil: RouteUtilService,
    private alertService: AlertsService,
    private principalService: PrincipalService,
    private dayBoardService: DayboardDateService,
    private breakpointObserver: BreakpointObserver,
    private sessionStorage: SessionStorageService,
    private homeService: HomeService,
    private preferenceService: PreferenceService,
    private receiveShipmentService: ReceiveShipmentService,
    public dialogRef: MatDialogRef<EntityVerificationFormComponent>,
    private dialog: MatDialog,
  ) {
  }

  /*********************Constructor*********************/

  /*********************Lifecyle Methods*********************/
  ngOnInit() {
    this.isWasteDisabled = false;
    this.subscription.preferences = this.preferenceService.preferences$.subscribe(
      (account) => {
        this.loadPreferences();
        this.getManufacturerOrderPref();
      }
    );
    this.menuOptionDisplay = this.menuOption;
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait,
        Breakpoints.TabletPortrait])
      .subscribe((result: BreakpointState) => {
        this.menuList = this.orgmenuOption
          .filter((option) => option.isMenuVisible == true)
          .map(function (x) {
            x.subItems = x.subItems.filter(
              (y) => y.isMenuVisible == true
            );
            return x;
          });
        if (result.matches) {
          this.isMobileView = true;
          this.menuList = this.menuOptionDisplay
            .filter((option) => option.isMenuMobileVisible == true)
            .map(function (x) {
              x.subItems = x.subItems.filter(
                (y) => y.isSubMenuMobileVisible == true
              );
              return x;
            });
        } else {
          this.isMobileView = false;
        }
      });

    this.subscription.authenticated = this.principalService.authenticated$.subscribe(
      () => {
        this.getHL7AlertCount();
        this.showreportsMenu();
        this.checkDigiRadAccount();
      }
    );
    this.subscription.alertCounter = this.alertService.markAsViewedTriggered$.subscribe(
      () => {
        this.getHL7AlertCount();
      }
    );
    this.subscription.reservationUpdate = this.homeService.reservationsUpdate$.subscribe(
      (value) => {
        if (value) {
          this.manufacturerOrderCount = value.manufacturerOrderCount;
        }
      }
    );

    interval(this.hl7alertCountUpdateInterval)
      .subscribe(() => {
        this.getHL7AlertCount();
      });
    this.getEnablePOFlag();

    this.enable340BVerification = this.show340BEntityVerificationFormPreference();
    this.enableWrittenDirectives = this.showWrittenDirectiveSubMenu();  
  }

  show340BEntityVerificationFormPreference(){
    let entityVerificationformFlag: any = {};
    if (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences)) {
      entityVerificationformFlag = (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences).filter((obj) => {
        return obj.preferenceKey.indexOf("SHOW_340B_ENTITY_VERIFICATION_FORM") !== -1;
      }))[0];
    }
     let enable340BVerification =  entityVerificationformFlag && (entityVerificationformFlag.preferenceValue == 'Y');
     return enable340BVerification;
  }

  showWrittenDirectiveSubMenu(){
    let writtenDirectivePrefFlag: any =  {};
    if(this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences)){
      writtenDirectivePrefFlag = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences).filter((obj) => {
        return obj.preferenceKey.indexOf("DMS_WRITTEN_DIRECTIVE_FLAG") !== -1;
      })[0];
    }
      return (writtenDirectivePrefFlag && writtenDirectivePrefFlag.preferenceValue == 'Y');
  }
  /*********************Lifecyle Methods*********************/

  /*********************Component Methods*********************/

  loadPreferences() {
    this.isWasteDisabled = this.preferenceService.getPreference(AppConstant.Preferences.DISABLE_WASTE_SYSTEM).value;
  }

  showreportsMenu() {
    if (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences)) {
      let idnPref = (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences).filter(digirad => {
        return digirad.preferenceKey.indexOf("NUCTRAC_SHOW_IDN_REPORT") !== -1;
      }))[0];
      if (idnPref && idnPref.preferenceValue == 'Y') {
        this.isIDNAccount = true;
      } else {
        this.isIDNAccount = false;
      }
    }
    this.menuList.forEach(menu => {
      if (menu.name === "reports") {
        menu.subItems = this.isIDNAccount ? IdnReports : NonIdnReports;
      }
    });
  }

  checkDigiRadAccount() {
    let digiradDOTPref = null
    if (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences)) {
      digiradDOTPref = (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.NuctracAppPreferences).filter(function (digirad) {
        return digirad.preferenceKey.indexOf("NUCTRAC_SHOW_DIGIRAD_REPORT") !== -1;
      }))[0];
    }
    if (digiradDOTPref && digiradDOTPref.preferenceValue == 'Y') {
      this.isDigiradAccount = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.IsAccountHuborFacility) ?
        (this.sessionStorage.retrieve(CacheConstant.SessionStorageData.IsAccountHuborFacility).facilityFlag || this.sessionStorage.retrieve(CacheConstant.SessionStorageData.IsAccountHuborFacility).hubFlag) : false;
    } else {
      this.isDigiradAccount = false;
    }
  }

  onMainMenuClicked(event: any, currentIndex: any) {
    this.Url = this.menuOptionDisplay[currentIndex].url;
    this.dayBoardService.refreshBt$.next(true);
    this.menuList[currentIndex].config.highlight = true;

    if (this.menuOptionDisplay[currentIndex].subItems?.length == 0) {
      if (this.router.url == '/inventory/receive-shipment') {
        this.receiveShipmentService.$showUnsaveMessage.next({'showMsg': true, 'url': this.Url});
        return;
      }
      this.router.navigateByUrl(this.Url);
      this.collapseAnother(currentIndex);
      if (this.isMobileView) {
        this.onOpenCloseMenuClick();
      }
    } else {
      event.stopPropagation();
      this.menuList[currentIndex].config.highlight = true;
      this.menuList[currentIndex].config.showSubMenu = !this.menuList[currentIndex].config.showSubMenu;
      this.collapseAnother(currentIndex);
      if (currentIndex == 6) {
        if (this.menuOptionDisplay[currentIndex].subItems.length == 2) {
          let reservationAlertObj = {
            title: 'Manufacturer Order Alerts',
            name: 'manufacturer-order-alerts',
            url: AlertsRoutes.ManufacturerOrderAlerts.Url,
            isMenuVisible: true,
            config: {highlight: false}
          };
          this.menuOptionDisplay[currentIndex].subItems.splice(2, 0, reservationAlertObj);
        }
      }
    }
  }

  collapseAnother(index) {
    this.menuList.forEach((el, i) => {
      if (i != index) {
        this.menuList[i].config.showSubMenu = false;
        this.menuList[i].config.highlight = false;
      }
    });
  }

  collapseAll() {
    setTimeout(() => {
      this.menuList.forEach((el) => {
        el.config.showSubMenu = false;
        if (el.subItems) {
          el.subItems.forEach((submenu) => {
            submenu.showSubMenuItems = false;
          });
        }
      });
    }, 100)
  }

  collapseAll2() {
    this.menuList.forEach((el) => {
      el.config.highlight = false;
      el.config.showSubMenu = false;
      if (el.subItems) {
        el.subItems.forEach((submenu) => {
          submenu.showSubMenuItems = false;
        });
      }
    });
  }

  onSubItemClicked(subItem: any) {
    if (subItem.subMenuItems?.length > 0) {
      subItem.showSubMenuItems = !subItem.showSubMenuItems;
    } else {
      this.collapseAll();
      if (this.isMobileView) {
        this.onOpenCloseMenuClick();
      }
      this.Url = subItem.url;
      if (subItem.name === MasterRoutes.Home) {
        this.dayBoardService.refreshBt$.next(true);
      } else {
        this.dayBoardService.refreshBt$.next(false);
      }
      if (this.router.url == '/inventory/receive-shipment' && this.Url != 'inventory/receive-shipment') {
        this.receiveShipmentService.$showUnsaveMessage.next({'showMsg': true, 'url': this.Url});
        return;
      }
      if (subItem.name === 'manage-waste' && this.isWasteDisabled) {
        this.router.navigate(['/home']);
      } else {
        this.router.navigateByUrl(this.Url);
      }
    }
  }

  onSubMenuItemClicked(subMenu: any) {
    this.collapseAll();
    this.Url = subMenu.url;
    this.dayBoardService.refreshBt$.next(false);
    if (subMenu.name == 'training') {
      let url =
        'https://www.cardinalhealth.com/en/product-solutions/pharmaceutical-products/nuclear-medicine/business-and-practice-management/nuctrac/help-center.html';
      window.open(url);
    } else {
      if (this.router.url == '/inventory/receive-shipment') {
        this.receiveShipmentService.$showUnsaveMessage.next({'showMsg': true, 'url': this.Url});
        return;
      }
      if (subMenu.name == '340B-entity-verification') {
        this.openEntityVerificationForm340b();
        return;
      }
      switch (subMenu.name) {
        case SettingsRoutes.SiteMaster.Name: {
          this.router.navigateByUrl(this.Url, {state: {id: '1'}});
          break;
        }
        case SettingsRoutes.RouteMaster.Name: {
          this.router.navigateByUrl(this.Url, {state: {id: '2'}});
          break;
        }
        case SettingsRoutes.PatientClassMaster.Name: {
          this.router.navigateByUrl(this.Url, {state: {id: '3'}});
          break;
        }
        case SettingsRoutes.TrackingCodesMaster.Name: {
          this.router.navigateByUrl(this.Url, {state: {id: '4'}});
          break;
        }
        default: {
          this.router.navigateByUrl(this.Url);
          break;
        }
      }
    }
  }

  onOpenCloseMenuClick() {
    this.showMenubar = !this.showMenubar;
  }

  openEntityVerificationForm340b() {
    this.dialogRef = this.dialog.open(EntityVerificationFormComponent,{
      width: '1000px',
      panelClass: 'add-scroll-bar',
      disableClose: true
    });
  }

  /*********************Component Methods*********************/

  /*********************Private Methods*********************/
  getHL7AlertCount(): void {
    this.alertService.getAlertCount().subscribe((response: IResponse) => {
      if (!response.hasError) {
        this.alerts = response.data.alertCount;
        this.alertCount = this.alerts.length;
        this.hl7alertCount = response.data.hl7alertCount;
        this.alerts.forEach((item) => {
          if (item[1] == 13000) {
            this.isHighAlert = true;
          }
        });
      }
    });
  }

  getEnablePOFlag() {
    this.principalService.identity().then((response: any) => {
      this.enablePOLink = response.enablePOFlag;
    });
  }
  getManufacturerOrderPref(){

    if (this.preferenceService.getPreference(
            AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
        )
        && this.preferenceService.getPreference(
            AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
       ).value) {

      this.manufacturerOrderPref = this.preferenceService.getPreference(
          AppConstant.Preferences.DISABLE_MANUFACTURER_ORDER
      ).value;      
    }
  }

  /*********************Private Methods*********************/
}
